import { IPartVertex } from '@stair-craft/calc/util';

import { serializeDxf } from './dxf-document';
import { EDxfEntityKind, IDxfPolyline, IDxfVertex, entitiesBounds } from './dxf-entities';
import { DXF_PART_LAYER, partLayers } from './dxf-layers';
import { DXF_PAPER_SIZE } from './dxf-sheet';

/**
 * One board to cut as a DXF 2007 file in millimetres: the same header and tables as the drawing,
 * and in model space one closed polyline on the outline layer, its arcs as vertex bulges. The
 * sheet is empty — a part file goes to the nesting, not to print.
 */
export function writePartDxf(outline: readonly IPartVertex[]): string {
    const polyline: IDxfPolyline = {
        kind: EDxfEntityKind.Polyline,
        layer: DXF_PART_LAYER,
        ltScale: 1,
        closed: true,
        vertices: outline.map((vertex: IPartVertex): IDxfVertex => ({ at: [vertex.x, vertex.y], bulge: vertex.bulge })),
    };
    return serializeDxf({
        layers: partLayers(),
        model: [polyline],
        paper: [],
        viewports: [],
        modelExtents: entitiesBounds([polyline]),
        paperSize: DXF_PAPER_SIZE,
        sheetName: $localize`:@@dxfStampSheet:Лист` + ' 1',
    });
}
